export default __webpack_public_path__ + "static/media/7.30f3a20b.png";